export default __webpack_public_path__ + "static/media/serverErrorImage.5d9da321.svg";